import React from 'react';
import { ThemeProvider } from './src/context/ThemeContext';
import './src/styles/reset.css';
import './src/styles/global.css';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <ThemeProvider>{element}</ThemeProvider>
);
